<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script> 

<style>
body {
  margin: 0;
  background: #f5f6fa;
  color: #333;
}
.tabBox .el-tag {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue